module.exports = __webpack_public_path__ + "static/media/filter-down-arrow-arc.54529900.svg";